import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { IntlProvider } from 'react-intl';
import pt from '../translations/pt.json';
import configureStore, { history } from '../store';
import Routes from '../routes';

const { language } = navigator;

const { store, persistor } = configureStore();

export { store };

const App = () => (
  <IntlProvider key={language} locale={language} messages={pt}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedRouter history={history}>
          <Routes />
        </ConnectedRouter>
      </PersistGate>
    </Provider>
  </IntlProvider>
);

export default App;
